export default __webpack_public_path__ + "static/media/neg-x.b88a0f33.jpg";